import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type TextsSettingsParams = {
  titleText: SettingsParamType.Text
  allLocationsTabText: SettingsParamType.Text
  reserveNowButtonText: SettingsParamType.Text
  learnMoreButtonText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.title'),
  },
  allLocationsTabText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.all-locations-tab'),
  },
  reserveNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.reserve-now-cta'),
  },
  learnMoreButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.learn-more-cta'),
  },
})
